module.exports = __webpack_public_path__ + "images/blog_guide/flow04_e9607f3bd8ec4e1acd1432d63764a84d.png";